import Link from 'next/link';
import { IoArrowBackOutline } from 'react-icons/io5';
import { Image } from '@components';
export const NoSessionPage = ({
  message
}: {
  message?: string;
}) => {
  return <>
      <div className='flex h-full w-full flex-col items-center justify-center'>
        <div className='relative mb-6 size-64'>
          <Image src='/layout/sad_emoji.png' objectFit='contain' fill alt='no session' />
        </div>
        <div className='font-bold text-red-500 text-xl'>
          <p>{message ? message : 'No User Session'}</p>
        </div>
        <p>Please open this app from MyAIS</p>
        <Link href='myais://'>
          <button className='mt-6 flex w-full items-center justify-center gap-1 rounded-md bg-primary px-6 py-1 text-black'>
            <IoArrowBackOutline />
            <p>My AIS</p>
          </button>
        </Link>
      </div>
    </>;
};